export var err = function (reason) { return ({
    reason: reason,
    error: new Error(reason)
}); };
